module.exports = __webpack_public_path__ + "img/Page not Found.6de1dc52.svg";